import { getQuery } from "@conectate/components/ct-router";
import { css } from "lit";

import { addFont, inyectStyles } from "../../base/styles/default-theme.js";

export namespace Simera {
	export const isSimeraHostname = () => window.app.hostname.includes("simera");
	export const isSimeraID = (id: string) => ["-NxyuDhTrtDP" /* Simera-incae */, "-NywQ5vJzu7d" /* Simera Interno */].includes(id);
	export const SimeraLogo = "https://cdn.hirex.app/partners%2Fsimera.webp";
	export const SimeraLogoWhite = "https://cdn.hirex.app/partners/simera_white.webp";
	export const simera_theme = css`
		:root,
		.dark {
			--color-primary: #8cffc3;
			--color-primary-medium: #8cffc3b0;
			--color-primary-light: #8cffc32b;
			--color-on-primary: #0e212d;
			--color-primary-hover: #8cffc3;
			--color-primary-active: #78d8a6;
			--color-secondary: #8cffc3;

			--color-secondary: #8cffc3;
			/* Color de objeto en cima de color de acento */
			--color-on-secondary: #0e212d;

			/* --color-background: linear-gradient(45deg, #052522 20%, #051823 70%, #083834); */
			--color-background: #061823;
			--color-on-background: #e8e8e8; /* Gris */
			--color-surface: #092432;
			--color-on-surface: #eaeaea;

			--high-emphasis: #ffffffde;
			--medium-emphasis: #ffffff99;
			--color-disable: #ffffff61;

			--color-app: #8cffc3;
			--color-blur: #1a2c34b3;
			--color-blur-surface: #1a2c34b3;
			--color-menu: #30505e;

			/* --ct-card-box-shadow: 0px 1px 8.6px 0px #8cffc340; */
			--font-title: "Rubik", sans-serif;
		}
		body {
			/* background:
				url(/static/img/aliados/simera/WorldBG.svg) left bottom no-repeat,
				linear-gradient(45deg, #052522 20%, #051823 70%, #083834) left bottom no-repeat,
				var(--color-background) center center / cover fixed; */

			background:
				url(/static/img/aliados/simera/WorldBG.svg) left bottom no-repeat fixed,
				linear-gradient(45deg, #052522 20%, #051823 70%, #083834) left bottom no-repeat fixed,
				var(--color-background) center center / cover fixed;
		}
	`;
	export const inyectTheme = () => {
		inyectStyles({ css: Simera.simera_theme.toString(), id: "simera" });
		addFont(`Rubik:400,500,700`);
	};

	export function getToolbarImg(id: string, profile?: string) {
		switch (profile) {
			case "1721338732977":
				return "/static/img/aliados/simera/simera_u_don_bosco.png";
			case "1724101272754":
				// Ciber tec
				return "/static/img/aliados/simera/cibertec.png";
			case "1726241079339":
				// Stellenbosch University
				return "/static/img/aliados/simera/university_stellenbosch.png";
			case "1731008697717":
				// AlHussein_Technical
				return "/static/img/aliados/simera/AlHussein_Technical_white.png";
			case "1731354524878":
				// English
				return "/static/img/aliados/simera/english_white.png";
			case "1731354557544":
				// English
				return "/static/img/aliados/simera/english_white.png";
		}
		if (id == "-NxyuDhTrtDP" /* Simera-incae */) {
			return "https://cdn.hirex.app/partners%2Fsimera_incae_.webp";
		}
	}
	export function getImgHeadersReport(id: string) {
		if (id == "-NxyuDhTrtDP" /* Simera-incae */) {
			return {
				page: SimeraLogo,
				hirex: "https://moria.aurens.com/organizations/be941267-eb6e-43b0-8115-e9e5b7e6b691/logos/9e3dbc-logo-1633655943.jpg"
			};
		} else if (id == "-NywQ5vJzu7d" /* Simera Interno */) {
			let profile = getQuery().get("profile");
			switch (profile) {
				case "1721338732977":
					// UDB
					return { page: SimeraLogo, hirex: "/static/img/aliados/simera/Universidad_don_bosco.jpg" };
				case "1724101272754":
					// Ciber tec
					return { page: SimeraLogo, hirex: "/static/img/aliados/simera/cibertec.png" };
				case "1726241079339":
					// Stellenbosch University
					return { page: SimeraLogo, hirex: "/static/img/aliados/simera/university_stellenbosch.png" };
				case "1731008697717":
					// AlHussein_Technical
					return { page: SimeraLogo, hirex: "/static/img/aliados/simera/AlHussein_Technical.png" };
				case "1731354524878":
					// English
					return { page: SimeraLogo, hirex: "/static/img/aliados/simera/english.png" };
				case "1731354557544":
					// English
					return { page: SimeraLogo, hirex: "/static/img/aliados/simera/english.png" };
			}
			return {
				page: SimeraLogo,
				hirex: ""
			};
		}
		return {
			page: `/static/psyco-app/psycoapp-logo.svg`,
			hirex: `/static/hirex-app/logos/logo-hireX-black.svg`
		};
	}
}
